export default {
  zh: {
    reward: '邀请奖励',
    benefits: '邀请收益',
    recharge: '充值提成',
    commission: '非首次提成',
    withdraw: '立即提现',
    coin: '可提现金币',
    gold: '金币',
    details: '金币明细',
    invitation: '我的邀请',
    time: '时间',
    type: '类型',
    content: '邀请1个用户并完成注册，获得700金币(隔天发送)',
    text: '邀请的朋友首次充值，获得其30%的金币',
    tips: '邀请的朋友非首次充值，获得7%的金币',
    share: '分享至',
    link: '我在App和朋友一起聊天，请来加入我们吧! ',
    number: '数量',
    setTest: '页面关闭'
  },
  en: {
    reward: 'Invitation Reward',
    benefits: 'Invitation benefits',
    recharge: 'Frist Recharge Reward',
    commission: 'Recharge Reward',
    withdraw: 'Withdraw',
    coin: 'Withdrawable coins',
    gold: 'coins',
    details: 'Coin Details',
    invitation: 'Invitation',
    time: 'time',
    type: 'type',
    content: 'Invite a user and complete the registration to get 700 coins',
    text: 'Invite friends to recharge for the first time, get 30% gold coins',
    tips: 'Get 7% gold coins every time your invited friends recharge',
    share: 'Share to',
    link: 'Come join me at Yayya. ',
    number: 'number',
    setTest: 'This event has ended'
  },
  ar: {
    reward: 'مكافأة الدعوة',
    benefits: 'فوائد الدعو',
    recharge: 'عمولة الشحن',
    commission: 'عموله الشحن المستمر',
    withdraw: 'سحب الآن',
    coin: 'العملات المعدنية القابلة للسحب',
    gold: 'ذهب',
    details: 'تفاصيل العملة الذهبية',
    invitation: 'دعوتي',
    time: 'الوقت',
    type: 'نوع التغيير',
    content: 'قم بدعوة شخص واحد لإتمام التسجيل والحصول على 700 قطعة ذهبية',
    text: 'قم بدعوة الأصدقاء لإعادة الشحن لأول مرة ، واحصل على 30٪ من العملات الذهبية',
    tips: 'احصل على 7% عملات ذهبية في كل مرة يشحن صديقك الذي قمت بدعوتة',
    share: 'Share to',
    link: 'تعال وانضم لي',
    number: 'عدد',
    setTest: 'تم  انتهاء الحدث'
  },
  tr: {
    reward: 'Davet Ödülü',
    benefits: 'Davetiye Avantajları',
    recharge: 'İlk Çekim Ödülü',
    commission: 'Çekim Ödülü',
    withdraw: 'Çekilebilir Coinsler',
    coin: 'Davetiye Avantajları',
    gold: 'Paylaş',
    details: 'Davet',
    invitation: 'Zaman',
    time: 'Tip',
    type: 'Coinsler',
    content: '700 coins kazanmak için bir kullanıcıyı davet edin ve kaydı tamamlayın',
    text: 'Arkadaşlarınızı ilk kez çekime  davet edin, Yaptığı ilk çekimin %30 bonusunu kazanın',
    tips: 'Davet ettiğiniz arkadaşlarınızın her yükleme yaptığında %7 altın kazanın',
    share: 'Davet İçin Link Paylaşın',
    link: 'Come join me at Yayya. ',
    number: 'number',
    setTest: 'Etkinlik bitti'
  },
  pt: {
    reward: 'Recompensa de Convite',
    benefits: 'Benefícios do Convite',
    recharge: 'Recompensa de Primeira Recarga',
    commission: 'Recompensa de Recarga',
    withdraw: 'Retirar',
    coin: 'Moedas retiráveis',
    gold: 'moedas',
    details: 'Detalhes das Moedas',
    invitation: 'Convite',
    time: 'tempo',
    type: 'tipo',
    content: 'Convide um usuário e complete o cadastro para ganhar 700 moedas',
    text: 'Convide amigos para recarregar pela primeira vez, ganhe 30% de moedas de ouro',
    tips: 'Ganhe 7% de moedas de ouro toda vez que seus amigos convidados recarregarem',
    share: 'Compartilhar para',
    link: 'Venha se juntar a mim no Yayya.',
    number: 'número',
    setTest: 'Este evento terminou'
  },
  id: {
    reward: 'Hadiah Undangan',
    benefits: 'Manfaat Undangan',
    recharge: 'Hadiah Pengisian Ulang Pertama',
    commission: 'Hadiah Pengisian Ulang',
    withdraw: 'Tarik',
    coin: 'Koin yang dapat ditarik',
    gold: 'koin',
    details: 'Rincian Koin',
    invitation: 'Undangan',
    time: 'waktu',
    type: 'tipe',
    content: 'Undang pengguna dan selesaikan registrasi untuk mendapatkan 700 koin',
    text: 'Undang teman untuk mengisi ulang pertama kali, dapatkan 30% koin emas',
    tips: 'Dapatkan 7% koin emas setiap kali teman yang diundang mengisi ulang',
    share: 'Bagikan ke',
    link: 'Ayo bergabung dengan saya di Yayya.',
    number: 'nomor',
    setTest: 'Acara ini telah berakhir'
  }
}



// WEBPACK FOOTER //
// src/pages/app/share/lang.js